import { render } from "./MaterialConfigModal.vue?vue&type=template&id=07110e7e&scoped=true"
import script from "./MaterialConfigModal.vue?vue&type=script&lang=js"
export * from "./MaterialConfigModal.vue?vue&type=script&lang=js"

import "./MaterialConfigModal.vue?vue&type=style&index=0&id=07110e7e&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07110e7e"]])

export default __exports__